import React from "react";
import {Col, Divider, Row, Steps, Typography, Form, Input, InputNumber, Button, Result, Layout} from "antd";
import MenuDashboard from "./Menu";
import HeaderMember from "./HeaderMember";
import ListeCmd from "./ListeCmd";
import {SmileOutlined} from '@ant-design/icons';
import axios from "axios";
import {API_URI} from "../../constant/Config";
import {FooterApps} from "../order/inc/FooterApps";
import {t} from '../../constant/i18n';
import {THEME} from '../../constant/theme';

const {Title, Text, Link} = Typography;
const {Step} = Steps;
const layout = {
    labelCol: {span: 0},
    wrapperCol: {span: 0},
};

const validateMessages = {
    required: '${label} is required!',
    types: {
        email: '${label} is not a valid email!',
        number: '${label} is not a valid number!',
    },
    number: {
        range: '${label} must be between ${min} and ${max}',
    },
};

class Contact extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            formZone: this.form(),
            id: localStorage.getItem('membre_id'),
        }
    }

    sendForm = async (values) => {

        await await axios.post(API_URI + '/api_member/contact-member', {id: this.state.id, msg: values.msg});

        this.setState({
            formZone: <Result
                icon={<SmileOutlined/>}
                title={t('contact.msgSent')}
                extra={<Button onClick={this.retourForm} type="primary">{t('common.back')}</Button>}
            />,
        })
    }

    retourForm = () => {
        this.setState({formZone: this.form()})
    }

    form = () => {
        return (
            <Form {...layout} name="nest-messages" onFinish={this.sendForm} validateMessages={validateMessages}>
                <Form.Item name={['msg']} label="">
                    <Input.TextArea rows={10}/>
                </Form.Item>
                <Form.Item wrapperCol={{...layout.wrapperCol, offset: 0}}>
                    <Button type="primary" htmlType="submit">
                        {t('contact.sendMyMsg')}
                    </Button>
                </Form.Item>
            </Form>
        );
    }

    render() {
        return (
            <Layout>
                <HeaderMember/>
                <Layout>
                    <MenuDashboard/>
                    <Layout>
                        <div className="contentBox">
                            <Title>{t('contact.contactUs')}</Title>

                            <Text>{t('contact.desc1')}<br/>
                                {t('contact.desc2')}<a
                                    target="_blank"
                                    href={THEME.urls.appointment}>{THEME.urls.appointment}</a>{t('contact.desc3Before')}<a
                                    href={'tel:' + THEME.phone.tel}>{THEME.phone.display}</a>{t('contact.desc3After')}

                                <br/>
                                {t('contact.desc4')}</Text>
                            <Divider/>
                            {this.state.formZone}
                        </div>
                    </Layout>
                </Layout>
                <Divider dashed/>
                <FooterApps/>
            </Layout>
        );
    }
}

export default Contact;